<template>
    <v-app>
        <vue-headful title="ePlato"/>
        <toolbar @toggleDrawer="drawerApp = !drawerApp"/>

        <navigation v-if="$route.name !== 'deanSuperAdminPreselect'" @toggleDrawer="drawerApp = $event" :drawer="drawerApp"/>

        <v-main>
            <router-view/>
        </v-main>
        <snack-displayer/>
    </v-app>
</template>

<script>
    import Toolbar from "../../components/dean/common/DeanToolbar";
    import DeanNavigationDrawer from "../../components/dean/common/DeanNavigationDrawer";
    import SnackDisplayer from "../../components/common/SnackDisplayer";

    export default {
        components: {
            toolbar: Toolbar,
            navigation: DeanNavigationDrawer,
            snackDisplayer: SnackDisplayer,
        },
        data: () => ({
            drawerApp: true,
        }),
    }
</script>
